/**
 * Created by Bart Decorte
 * Date: 2019-04-16
 * Time: 20:47
 */

export default class Gravity {
  constructor($element, params = {}) {
    const { width, height, dontCrop, gravity } = params;
    this.$element = $element;
    this.position = { x: 0, y: 0 };

    this.positions = {
      n: { x: 0, y: -1 },
      ne: { x: 1, y: -1 },
      e: { x: 1, y: 0 },
      se: { x: 1, y: 1 },
      s: { x: 0, y: 1 },
      sw: { x: -1, y: 1 },
      w: { x: -1, y: 0 },
      nw: { x: -1, y: -1 },
      c: { x: 0, y: 0 },
    };

    this.shiftMap = {
      '0': {
        '-1': {
          n: 'c',
          ne: 'e',
          e: 'se',
          se: null,
          s: null,
          sw: null,
          w: 'sw',
          nw: 'w',
          c: 's',
        },
        '0': {
          n: 'n',
          ne: 'ne',
          e: 'e',
          se: 'se',
          s: 's',
          sw: 'sw',
          w: 'w',
          nw: 'nw',
          c: 'c',
        },
        '1': {
          n: null,
          ne: null,
          e: 'ne',
          se: 'e',
          s: 'c',
          sw: 'w',
          w: 'nw',
          nw: null,
          c: 'n',
        },
      },
      '-1': {
        '-1': {
          n: 'ne',
          ne: null,
          e: null,
          se: null,
          s: null,
          sw: null,
          w: 's',
          nw: 'c',
          c: 'se',
        },
        '0': {
          n: 'ne',
          ne: null,
          e: null,
          se: null,
          s: 'se',
          sw: 's',
          w: 'c',
          nw: 'n',
          c: 'e',
        },
        '1': {
          n: null,
          ne: null,
          e: null,
          se: null,
          s: 'e',
          sw: 'c',
          w: 'n',
          nw: null,
          c: 'ne',
        },
      },
      '1': {
        '-1': {
          n: 'w',
          ne: 'c',
          e: 's',
          se: null,
          s: null,
          sw: null,
          w: null,
          nw: null,
          c: 'sw',
        },
        '0': {
          n: 'nw',
          ne: 'n',
          e: 'c',
          se: 's',
          s: 'sw',
          sw: null,
          w: null,
          nw: null,
          c: 'w',
        },
        '1': {
          n: null,
          ne: null,
          e: 'n',
          se: 'c',
          s: 'w',
          sw: null,
          w: null,
          nw: null,
          c: 'nw',
        },
      },
    };

    this.bindListeners();

    this.dontCrop = dontCrop;
    this.width = width;
    this.height = height;
    this.gravity = gravity;
  }

  set width(width) {
    if (width === '' || typeof width === typeof undefined) {
      this._width = undefined;
    } else {
      this._width = parseInt(width);
    }
    this.render();
  }

  get width() {
    return this._width;
  }

  set height(height) {
    if (height === '' || typeof height === typeof undefined) {
      this._height = undefined;
    } else {
      this._height = parseInt(height);
    }
    this.render();
  }

  get height() {
    return this._height;
  }

  set dontCrop(dontCrop) {
    this._dontCrop = dontCrop == true;
    this.render();
  }

  get dontCrop() {
    return this._dontCrop;
  }

  set gravity(gravity) {
    if (gravity.length > 2) {
      gravity = this.windShort(gravity);
    }
    this._gravity = gravity;
    this.position = this.positions[gravity];
    this.updateInput(this.windLong(gravity));
    this.render();
  }

  get gravity() {
    return this._gravity;
  }

  bindListeners() {
    this.$element.on('click', '[data-position]', (ev) =>
      this.lPositionClicked(ev)
    );
  }

  lPositionClicked(ev) {
    ev.preventDefault();
    let $elt = $(ev.target).is('[data-position]')
      ? $(ev.target)
      : $(ev.target)
          .parents('[data-position]')
          .first();
    this.gravity = $elt.data('position');
    return false;
  }

  render() {
    const map = this.shiftMap[this.position.x][this.position.y];
    const $buttons = this.$element.find('[data-position]');
    for (let i = 0; i < $buttons.length; i++) {
      let $button = $($buttons[i]);
      let position = $button.data('position');
      $button.attr('data-direction', map[position]);
      $button.prop(
        'disabled',
        this.dontCrop ||
          typeof this.width === typeof undefined ||
          typeof this.height === typeof undefined
      );
    }
  }

  updateInput(value) {
    this.$element.find('input').val(value);
  }

  windLong(windShort) {
    const map = { n: 'north', s: 'south', e: 'east', w: 'west', c: 'center' };
    let windLong = windShort;
    Object.keys(map).forEach((key) => {
      windLong = windLong.replace(key, map[key]);
    });
    return windLong;
  }

  windShort(windLong) {
    const map = { north: 'n', south: 's', east: 'e', west: 'w', center: 'c' };
    let windShort = windLong;
    Object.keys(map).forEach((key) => {
      windShort = windShort.replace(key, map[key]);
    });
    return windShort;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utils/Gravity.js